/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SILDiscountApplied } from './SILDiscountApplied';
import {
    SILDiscountAppliedFromJSON,
    SILDiscountAppliedFromJSONTyped,
    SILDiscountAppliedToJSON,
} from './SILDiscountApplied';

/**
 * 
 * @export
 * @interface SILPriceProductValue
 */
export interface SILPriceProductValue {
    /**
     * 
     * @type {number}
     * @memberof SILPriceProductValue
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof SILPriceProductValue
     */
    valueWithVat?: number;
    /**
     * 
     * @type {number}
     * @memberof SILPriceProductValue
     */
    totalValue?: number;
    /**
     * 
     * @type {number}
     * @memberof SILPriceProductValue
     */
    totalValueWithVat?: number;
    /**
     * 
     * @type {number}
     * @memberof SILPriceProductValue
     */
    fullValue?: number;
    /**
     * 
     * @type {number}
     * @memberof SILPriceProductValue
     */
    fullValueWithVat?: number;
    /**
     * 
     * @type {number}
     * @memberof SILPriceProductValue
     */
    fullTotalValue?: number;
    /**
     * 
     * @type {number}
     * @memberof SILPriceProductValue
     */
    fullTotalValueWithVat?: number;
    /**
     * 
     * @type {string}
     * @memberof SILPriceProductValue
     */
    discountAppliedId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SILPriceProductValue
     */
    netto?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SILPriceProductValue
     */
    priorityPrice?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SILPriceProductValue
     */
    priceType?: SILPriceProductValuePriceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SILPriceProductValue
     */
    discountRowType?: SILPriceProductValueDiscountRowTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SILPriceProductValue
     */
    productId?: string;
    /**
     * 
     * @type {number}
     * @memberof SILPriceProductValue
     */
    quantity?: number;
    /**
     * 
     * @type {SILDiscountApplied}
     * @memberof SILPriceProductValue
     */
    discountApplied?: SILDiscountApplied;
}


/**
 * @export
 */
export const SILPriceProductValuePriceTypeEnum = {
    Agreement: 'AGREEMENT',
    AgreementGroup: 'AGREEMENT_GROUP',
    Appropriation: 'APPROPRIATION',
    PriceList: 'PRICE_LIST',
    PositiveList: 'POSITIVE_LIST',
    Campaign: 'CAMPAIGN'
} as const;
export type SILPriceProductValuePriceTypeEnum = typeof SILPriceProductValuePriceTypeEnum[keyof typeof SILPriceProductValuePriceTypeEnum];

/**
 * @export
 */
export const SILPriceProductValueDiscountRowTypeEnum = {
    Appropriation: 'APPROPRIATION',
    GreenOrdination: 'GREEN_ORDINATION',
    AgreementGroup: 'AGREEMENT_GROUP',
    CampaignPart: 'CAMPAIGN_PART',
    CampaignSalesPromotionPart: 'CAMPAIGN_SALES_PROMOTION_PART',
    CampaignSalesPromotionNode: 'CAMPAIGN_SALES_PROMOTION_NODE'
} as const;
export type SILPriceProductValueDiscountRowTypeEnum = typeof SILPriceProductValueDiscountRowTypeEnum[keyof typeof SILPriceProductValueDiscountRowTypeEnum];


/**
 * Check if a given object implements the SILPriceProductValue interface.
 */
export function instanceOfSILPriceProductValue(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SILPriceProductValueFromJSON(json: any): SILPriceProductValue {
    return SILPriceProductValueFromJSONTyped(json, false);
}

export function SILPriceProductValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): SILPriceProductValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
        'valueWithVat': !exists(json, 'valueWithVat') ? undefined : json['valueWithVat'],
        'totalValue': !exists(json, 'totalValue') ? undefined : json['totalValue'],
        'totalValueWithVat': !exists(json, 'totalValueWithVat') ? undefined : json['totalValueWithVat'],
        'fullValue': !exists(json, 'fullValue') ? undefined : json['fullValue'],
        'fullValueWithVat': !exists(json, 'fullValueWithVat') ? undefined : json['fullValueWithVat'],
        'fullTotalValue': !exists(json, 'fullTotalValue') ? undefined : json['fullTotalValue'],
        'fullTotalValueWithVat': !exists(json, 'fullTotalValueWithVat') ? undefined : json['fullTotalValueWithVat'],
        'discountAppliedId': !exists(json, 'discountAppliedId') ? undefined : json['discountAppliedId'],
        'netto': !exists(json, 'netto') ? undefined : json['netto'],
        'priorityPrice': !exists(json, 'priorityPrice') ? undefined : json['priorityPrice'],
        'priceType': !exists(json, 'priceType') ? undefined : json['priceType'],
        'discountRowType': !exists(json, 'discountRowType') ? undefined : json['discountRowType'],
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'discountApplied': !exists(json, 'discountApplied') ? undefined : SILDiscountAppliedFromJSON(json['discountApplied']),
    };
}

export function SILPriceProductValueToJSON(value?: SILPriceProductValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'valueWithVat': value.valueWithVat,
        'totalValue': value.totalValue,
        'totalValueWithVat': value.totalValueWithVat,
        'fullValue': value.fullValue,
        'fullValueWithVat': value.fullValueWithVat,
        'fullTotalValue': value.fullTotalValue,
        'fullTotalValueWithVat': value.fullTotalValueWithVat,
        'discountAppliedId': value.discountAppliedId,
        'netto': value.netto,
        'priorityPrice': value.priorityPrice,
        'priceType': value.priceType,
        'discountRowType': value.discountRowType,
        'productId': value.productId,
        'quantity': value.quantity,
        'discountApplied': SILDiscountAppliedToJSON(value.discountApplied),
    };
}

